<template>
  <div>
    <b-collapse
      class="card"
      animation="slide"
      v-for="(doc, index) of documents"
      :key="index"
      :open="isOpen == index"
      @open="isOpen = index"
    >
      <h3 class="card-header-title" v-if="doc.meta">{{ doc.meta }}</h3>
      <div slot="trigger" slot-scope="props" class="card-header" role="button">
        <p v-if="doc.docId" class="card-header-title">
          <RouterLink
            :to="{ name: 'Document', params: { documentId: doc.docId } }"
          >
            {{ doc.title }}
          </RouterLink>
        </p>

        <p v-else class="card-header-title">
          {{ doc.title }}
        </p>

        <a v-if="doc.documents" class="card-header-icon">
          <b-icon :icon="props.open ? 'caret-down' : 'caret-up'"> </b-icon>
        </a>
      </div>
      <div v-if="doc.documents" class="card-content">
        <div class="content">
          <directory-tree
            :documents="doc.documents"
            :title="doc.title"
          ></directory-tree>
        </div>
      </div>
    </b-collapse>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isOpen: null,
    };
  },
  props: ["title", "documents"],
  name: "directory-tree",
};
</script>
